import { useState } from "react";
import { toast } from "sonner";
import { Plus, Pencil } from "lucide-react";
import { frApi, errMsg, cardCls, fieldCls, btnPrimary, btnGhost } from "./frUtils";

/** Boards / curricula (management). Aliases help match lead text such as "MP Board" or "IGCSE". */
export default function BoardsManager({ boards, onChanged }) {
    const [edit, setEdit] = useState(null);
    const [f, setF] = useState({ name: "", aliases: "" });
    const start = (b) => { setEdit(b ? b.id : "new"); setF({ name: b?.name || "", aliases: (b?.aliases || []).join(", ") }); };
    const save = async () => {
        const body = { name: f.name, aliases: f.aliases.split(",").map((x) => x.trim()).filter(Boolean) };
        try { await (edit === "new" ? frApi.post("/boards", body) : frApi.put(`/boards/${edit}`, body)); toast.success("Board saved"); setEdit(null); onChanged(); }
        catch (e) { toast.error(errMsg(e)); }
    };
    const form = (
        <div className="space-y-2" data-testid="fr-board-form">
            <input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} placeholder="Board name" className={fieldCls} data-testid="fr-board-form-name" />
            <input value={f.aliases} onChange={(e) => setF({ ...f, aliases: e.target.value })} placeholder="Other names (comma separated)" className={fieldCls} data-testid="fr-board-form-aliases" />
            <div className="flex gap-2"><button type="button" onClick={save} className={btnPrimary} data-testid="fr-board-form-save">Save</button><button type="button" onClick={() => setEdit(null)} className={btnGhost}>Cancel</button></div>
        </div>
    );
    return (
        <section className={`${cardCls} space-y-3`} data-testid="fr-boards">
            <div className="flex items-center justify-between">
                <h3 className="font-heading font-bold text-[#0F172A]">Boards & curricula</h3>
                <button type="button" onClick={() => start(null)} className="text-xs font-semibold text-[#1E3A8A] inline-flex items-center gap-1" data-testid="fr-board-add"><Plus className="w-3.5 h-3.5" /> Add board</button>
            </div>
            {edit === "new" && form}
            <div className="divide-y divide-slate-100">
                {boards.map((b) => (
                    <div key={b.id} className="py-2" data-testid={`fr-board-row-${b.key}`}>
                        {edit === b.id ? form : (
                            <div className="flex items-center gap-2">
                                <div className="flex-1 min-w-0"><div className="text-sm font-semibold">{b.name}</div><div className="text-xs text-slate-500 truncate">{(b.aliases || []).join(", ")}</div></div>
                                <button type="button" onClick={() => start(b)} aria-label={`Edit ${b.name}`} className="h-10 w-10 grid place-items-center text-slate-500" data-testid={`fr-board-edit-${b.key}`}><Pencil className="w-4 h-4" /></button>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </section>
    );
}
